import { Routes } from '@angular/router';
import { NewsFeedComponent } from './news-feed/news-feed.component';
import { NewsItemComponent } from './news-item/news-item.component';

/**
 * The news pages. An application mounts these at `/news` and states its feed
 * in the parent route's data, which both children inherit because the parent
 * has no component of its own:
 *
 * ```ts
 * {
 *   path: 'news',
 *   data: { label: 'News', translationKey: 'common.news', newsFeed: { … } satisfies NewsFeedDefinition },
 *   loadChildren: () => import('@frontend/common').then((m) => m.newsRoutes),
 * }
 * ```
 */
export const newsRoutes: Routes = [
  {
    path: '',
    component: NewsFeedComponent,
  },
  {
    path: ':slug',
    component: NewsItemComponent,
    data: { label: 'News item', translationKey: null, labelSource: 'titleService' },
  },
];
